import Pusher from "../../libs/pusher";
import {LogBox} from "react-native";

export class PusherRealtimeGateway {

    constructor(app_key, cluster) {
        // Enable pusher logging - don't include this in production
        Pusher.logToConsole = true;
        console.log(app_key)
        LogBox && LogBox.ignoreLogs(['Setting a timer'])

        this.pusher = new Pusher(app_key, {
            cluster
        });
    }

    watchCustomerUpdate(customer_id, callback) {
        const channel = this.pusher.subscribe(customer_id);
        channel.bind('update_me', callback)
    }
}
